import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=13e252c8&scoped=true&"
var script = {}
import style0 from "./HomePage.vue?vue&type=style&index=0&id=13e252c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e252c8",
  null
  
)

export default component.exports